var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFilter16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97158 2C2.5649 2 2.32834 2.45969 2.56472 2.79062L6.99999 9V11.5858C6.99999 11.851 7.10535 12.1054 7.29288 12.2929L8.14644 13.1464C8.46142 13.4614 8.99999 13.2383 8.99999 12.7929V9L13.4353 2.79062C13.6716 2.45968 13.4351 2 13.0284 2H2.97158Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;